import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"

import { Tooltip } from "reactstrap"

import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../services/adapters/kepegawaian/agamaService"

import DataTableBloc from '../Blocs/DataTableBloc'
import apiResponse from '../../../../../services/apiResponse'
import ReportDetailModal from '../../Report/Components/ReportDetailModal';
import ReportModal from '../../Report/Components/ReportModal';
import moment from "moment"


class TableActiveComponent extends Component {
    dataTableBloc = new DataTableBloc();

    userdata = JSON.parse(localStorage.getItem('userdata'));

    source
    historyTable = 'reportdetailall'
    defaultOrder = 'employee_current_work_unit_hirarki'
    defaultSize = 10
    defaultSort = 'desc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            tooltip: false,
            detailUuid: null,
            updateUuid: null,
            reportUuid: null,
            inactiveUuid: null,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: false,
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                },
            now: moment().format('YYYY-MM-DD'),
            uuid: props.uuid,
            reportDetail: null
        }
    }
    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });
    toggleDetail = () => {
        this.setState({ modalDetail: !this.state.modalDetail })
    }
    toggle = () => {
        this.setState({ modal: !this.state.modal })
    }
    dateParse = (input) => {
        let res = "-";
        if (input != "" && input != null) {
            res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        /* kirim ke server */
        let offset = (this.state.filter.page_number - 1) * this.state.filter.page_size
        if (this.state.defaultSize !== this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: this.props.filter?.status,
            employee_uuid: this.userdata?.employee_uuid,
            uuid: this.state.uuid,
            is_atasan: this.userdata?.is_atasan,
            work_unit_uuid: this.userdata?.employee_current_work_unit_uuid,
        }
        await this.dataTableBloc.fetchRowTable(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    confirmResponse = (response) => {
        let forState = {}
        switch (response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.inactiveData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
            case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:
        }
        this.setState(forState)
    }

    inactiveData = async () => {
        await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid })
    }

    componentDidMount() {
        // this.setTokenAPI()

        this.dataTableBloc.rowtableChanneldetail.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })

        this.dataTableBloc.inactiveChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                        loadingTable: true
                    }, function () {
                        this.setTokenAPI()
                        this.props.handleInactiveSuccess()
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })
    }

    componentWillUnmount() {
        this.dataTableBloc.rowtableChanneldetail.unsubscribe()
    }

    columns = [
        {
            key: "employee_nip",
            text: "NIP",
            className: "employee_nip",
            sortable: true,
        },
        {
            key: "employee_full_name",
            text: "Nama",
            className: "employee_full_name",
            sortable: true,
            // cell: record => {
            //     return this.dateParse(record.employee_full_name)
            // }
        },
        {
            key: "employee_current_work_unit_name",
            text: "Unit Kerja",
            className: "employee_current_work_unit_name",
            sortable: true,
            // cell: record => {
            //     return this.dateParse(record.employee_current_work_unit_name)
            // }
        },
        // ,
        // {
        //     key: "total_day",
        //     text: "Total Hari",
        //     className: "total_day",
        //     sortable: true,
        //     cell: record => {
        //         return `${record.total_day} Hari`;
        //     }
        // },
        {
            key: "employee_wfh_status",
            text: "Status Laporan",
            className: "employee_wfh_status",
            sortable: true,
            width: '100',
            cell: record => {
                return <label className={`badge rounded-pill ${record.employee_wfh_status_color_name} font-size-12`}>{record.employee_wfh_status_name}</label>
            }
        },
        {
            key: "action",
            text: "Aksi",
            className: "action",
            width: 120,
            sortable: false,
            align: 'center',
            cell: record => {
                const thisId = record.employee_wfh_detail_id
                const start_date = record.employee_wfh_start_date
                const status = record.employee_wfh_status
                const data = {
                    ...record
                }
                return (
                    <Fragment>
                        <span>
                            <button
                                className="btn btn-primary btn-sm"
                                id={"detail-" + thisId}
                                onClick={() => {
                                    this.setState({
                                        reportDetail: data,
                                    })
                                    this.toggleDetail()
                                    console.log(data)
                                }}
                                style={{
                                    marginRight: '2px',
                                    padding: '2px 5px'
                                }}>
                                <i className="uil-align-left"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2
                                }}
                                placement="top" isOpen={this.state["detail" + thisId]} target={"detail-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        ["detail" + thisId]: !this.state["detail" + thisId]
                                    })
                                }}
                            >Detil</Tooltip>
                        </span>
                        <button
                            className="btn btn-success btn-sm"
                            type='button'
                            id={"report-" + data.employee_wfh_detail_uuid}
                            onClick={() => {
                                this.setState({
                                    reportDetail: data,
                                })
                                this.toggle()
                            }}
                            style={{
                                padding: '2px 5px'
                            }}>
                            <i className="uil-edit-alt"></i>
                        </button>
                    </Fragment>
                );
            }
        }
    ]

    render() {
        return (
            <>
                <MKIDatatable
                    className={this.configDatatable.tableClass}
                    config={this.configDatatable}
                    records={this.state.rows}
                    columns={this.columns}
                    dynamic={true}
                    minWidth={1000}
                    total_record={this.state.totalRow}
                    initial={this.state.filter}
                    onChange={(filter) => {
                        this.setState({
                            loadingTable: true,
                            filter: filter
                        }, function () {
                            this.setTokenAPI()
                        });
                    }}
                    loading={this.state.loadingTable}
                />
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menghapus data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil dihapus"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal dihapus"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                {this.state.detailUuid !== null ?
                    <Redirect to={"/kepegawaian/pengajuan_wfh.html?detail&uuid=" + this.state.detailUuid} />
                    : null}
                {this.state.updateUuid !== null ?
                    <Redirect to={"/kepegawaian/pengajuan_wfh.html?update&uuid=" + this.state.updateUuid} />
                    : null}
                {this.state.reportUuid !== null ?
                    <Redirect to={"/kepegawaian/pengajuan_wfh.html?report&uuid=" + this.state.reportUuid} />
                    : null}
                <ReportDetailModal
                    modal={this.state.modalDetail}
                    toggle={() => this.toggleDetail()}
                    // periodUuid={this.state.period?.cpns_period_uuid} 
                    // setUuid={value => this.setUuid(value)} 
                    handleReload={() => this.setTokenAPI()}
                    nip={this.state.reportDetail?.employee_nip || this.state.reportDetail?.employee_wfh_report_nip || this.state.detail?.employee_nip}
                    reportDetail={this.state.reportDetail}
                    desc={this.state.desc}
                />
                <ReportModal
                    modal={this.state.modal}
                    toggle={() => this.toggle()}
                    // periodUuid={this.state.period?.cpns_period_uuid} 
                    // setUuid={value => this.setUuid(value)} 
                    handleReload={() => this.setTokenAPI()}
                    nip={this.state.reportDetail?.employee_nip || this.state.reportDetail?.employee_wfh_report_nip || this.state.detail?.employee_nip}
                    reportDetail={this.state.reportDetail}
                    desc={this.state.desc}
                />
            </>
        )
    }

}

export default TableActiveComponent